<template>
  <main class="app-main">
    <!--begin::App Content Header-->
    <div class="app-content-header">
      <!--begin::Container-->
      <div class="container-fluid">
        <!--begin::Row-->
        <div class="row">
          <div class="col-sm-6"><h3 class="mb-0">العملاء</h3></div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-end">
              <li class="breadcrumb-item"><router-link to="/">الرئيسية</router-link></li>
              <li class="breadcrumb-item active" aria-current="page">العملاء</li>
            </ol>
          </div>
        </div>
        <!--end::Row-->
      </div>
      <!--end::Container-->
    </div>
    <!--end::App Content Header-->
    <!--begin::App Content-->
    <div class="app-content">
      <!--begin::Container-->
      <div class="container-fluid">
        <div class="row">
          <div class="col text-end">
            <button v-if="checkAccess('users_export')" type="button" class="btn btn-success me-2" @click.prevent="exportExcel">
              <i class="fa fa-file-excel me-1"></i> تصدير Excel
            </button>
            <router-link v-if="checkAccess('users_create')" to="/clients/create" class="btn btn-primary">
              <i class="bi bi-plus-circle me-1"></i> إضافة عميل
            </router-link>
          </div>
        </div>
        <!--FILTER-->
        <div class="card shadow card-warning card-outline mt-5">
          <div class="card-header">
            <button
              class="filter-btn w-100 text-start collapse-toggle"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#filterCard"
              aria-expanded="false"
              aria-controls="filterCard"
            >
              <i class="fa-solid fa-magnifying-glass"></i> بحث وتصفية
            </button>
          </div>

          <div class="collapse" id="filterCard">
            <form action="" @submit.prevent="filterSubmit">
              <div class="card-body">
                <div class="row">
                  <div class="col-6 col-sm-3 mb-3">
                    <input type="text" v-model="searchName" class="form-control" placeholder="الاسم">
                  </div>
                  <div class="col-6 col-sm-3 mb-3">
                    <input type="text" v-model="searchMobile" class="form-control" placeholder="رقم الجوال">
                  </div>
                  <div class="col-6 col-sm-3 mb-3">
                    <input type="number" v-model="searchIdentity" class="form-control" placeholder="رقم الهوية">
                  </div>
                  <div class="col-6 col-sm-3 mb-3">
                    <select class="form-control" v-model="searchBlock">
                      <option :value="null">حالة الحظر</option>
                      <option :value="true">محظور</option>
                      <option :value="false">غير محظور</option>
                    </select>
                  </div>
                  <div class="col-6 col-sm-3 mb-3">
                    <select class="form-control" v-model="searchActivation">
                      <option value="">حالة التفعيل</option>
                      <option value="true">تم التفعيل</option>
                      <option value="false">غير مفعل</option>
                    </select>
                  </div>
                  <div 
                    class="d-flex align-items-center justify-content-between p-2 mb-2 rounded border"
                    @click="showDateFilter = !showDateFilter"
                    style="cursor:pointer; transition:0.3s;"
                    :class="showDateFilter ? 'bg-light border-primary' : ''"
                  >
                    <div class="d-flex align-items-center gap-2">
                      <i class="bi bi-calendar fs-5 text-primary"></i>
                      <span class="fw-bold">تاريخ الإنشاء</span>
                    </div>
                    <div>
                      <i :class="showDateFilter ? 'bi bi-chevron-up' : 'bi bi-chevron-down'"></i>
                    </div>
                  </div>
                  <div v-if="showDateFilter" class="row">
                    <div class="col-6 col-sm-3 mb-3">
                      <label class="form-label">من تاريخ</label>
                      <input type="date" v-model="searchDateFrom" class="form-control">
                    </div>
                    <div class="col-6 col-sm-3 mb-3">
                      <label class="form-label">إلى تاريخ</label>
                      <input type="date" v-model="searchDateTo" class="form-control">
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-footer">
                <div class="row">
                  <div class="col text-end">
                    <button type="submit" class="btn btn-warning btn-sm"><i class="fa-solid fa-filter"></i> بحث وتصفية</button> 
                    <button type="button" class="btn btn-light btn-sm ms-3" @click.prevent="clearFilter"><i class="fa-solid fa-filter-circle-xmark"></i> إلغاء</button> 
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
        <!--begin::Row-->
        <div class="row">
          <div class="col">
            <div class="card card-secondary card-outline mb-4 mt-5">
              <div class="card-header d-flex align-items-center">
                <div class="card-title mb-0">العملاء</div>
                <span v-if="countRows > 0"
                  class="badge rounded-pill bg-primary fs-6 px-3 py-2 ms-auto"> 
                  عدد النتائج ( {{ countRows }} )</span>
              </div>
              <errorAlert v-if="hasError" :alertMessage="message" :errorNumber="errorNumber" />
              <div class="card-body">
                <mainLoader v-if="mainLoading" />
                <div v-else class="row">
                  <div class="col">
                    <div class="table-responsive">
                      <table class="table table-striped">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>الاسم</th>
                            <th>الجوال</th>
                            <th>رقم الهوية</th>
                            <th>تفعيل الجوال</th>
                            <th>محظور</th>
                            <th>تاريخ الإنشاء</th>
                            <th>الرصيد</th>
                            <th>العمليات</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(row, indx) in rows" :key="`${row.id}${indx}`">
                            <td>{{ row.id }}</td>
                            <td>{{ row.name }}</td>
                            <td>
                              <a v-if="row.mobile" :href="waLink(row.mobile)" target="_blank" rel="noopener" class="text-decoration-none me-2" title="مراسلة عبر الواتساب">
                                <i class="bi bi-whatsapp text-success me-1"></i>
                              </a>
                              {{ row.mobile }}
                            </td>
                            <td>{{ row.identity }}</td>
                            <td>{{ (row.mobileVerified)? 'تم التفعيل' : 'غير مفعل' }}</td>
                            <td>{{ (row.isBlocked)? 'محظور' : 'غير محظور' }}</td>
                            <td>{{ $shortDate(row.createdAt) }}</td>
                            <td>{{ row.balance.toLocaleString() }}</td>
                            <td>
                              <router-link :to="`/clients/update/${row.id}`" class="btn btn-light btn-sm me-3">
                                <i v-if="checkAccess('users_update')" class="bi bi-pencil-square"></i>
                                <i v-else class="fa-regular fa-eye"></i>
                              </router-link>
                              <button v-if="checkAccess('users_delete')" class="btn btn-danger btn-sm" @click="deleteRow(row.id, indx)"><i class="bi bi-trash"></i></button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-footer">
                <div class="row">
                  <div class="col">
                    <ul class="pagination">
                      <li v-if="currentPage > 1" class="page-item"><a class="page-link" href="#" @click.prevent="prevPage()">السابق</a></li>
                      <li v-for="p in pages" :key="p" class="page-item">
                        <a v-if="p == currentPage" class="page-link active" href="javascript:void(0)">{{ p }}</a>
                        <a v-else class="page-link" href="javascript:void(0)" @click="goToPage(p)">{{ p }}</a>
                      </li>
                      <li v-if="rows.length >= 30" class="page-item"><a class="page-link" href="#" @click.prevent="nextPage()">التالي</a></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--end::Row-->
      </div>
      <!--end::Container-->
    </div>
    <!--end::App Content-->
  </main>
</template>

<script>
import { toast, checkAccess } from '@/helpers/tools';

export default {
  name: 'ClientsList',
  data(){
    return {
      mainLoading: true,
      hasError: false,
      message: '',
      errorNumber: 0,
      rows: [],
      currentPage: parseInt(this.$route.query.page) || 1,
      pages: [],
      searchName: this.$route.query.name || '',
      searchMobile: this.$route.query.mobile || '',
      searchIdentity: this.$route.query.identity || '',
      searchBlock: this.$route.query.block === 'true' ? true : this.$route.query.block === 'false' ? false : null,
      searchDateFrom: this.$route.query.dateFrom || null,
      searchDateTo: this.$route.query.dateTo || null,
      showDateFilter: false,
      countRows: 0,
      searchActivation: this.$route.query.mobileVerified || '',
    }
  },
  methods: {
    checkAccess,
    filterParams(){
      const params = {};
      if(this.searchName.trim()) params.name = this.searchName.trim();
      if(this.searchMobile.trim()) params.mobile = this.searchMobile.trim();
      if(this.searchIdentity) params.identity = this.searchIdentity;
      if(this.searchBlock !== null) params.block = this.searchBlock;
      if(this.searchActivation !== '') params.mobileVerified = this.searchActivation;
      if(this.searchDateFrom) params.dateFrom = this.searchDateFrom;
      if(this.searchDateTo) params.dateTo = this.searchDateTo;
      return params;
    },
    getList(){
      this.mainLoading = true;
      this.hasError = false;
      const params = { page: this.currentPage, ...this.filterParams() };
      this.$router.replace({ query: params }).catch(() => {});

      this.$http.get('/api/admin/users/list', { params }).then(({data}) => {
        this.rows = data.rows;
        this.pages = data.pages ?? [this.currentPage];
        this.countRows = data.countRows ?? 0; 
        this.mainLoading = false;
      }).catch(err => {
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    },
    async deleteRow(id, index){
      const deletePrompt = await this.$swal.fire({
        title: "هل تريد تأكيد حذف السجل ، لا يمكن استعادته مرة اخرى ؟",
        showCancelButton: true,
        confirmButtonText: "حذف",
        cancelButtonText: "إلغاء",
        confirmButtonColor: '#dc3741',
      });
      
      if (deletePrompt.isConfirmed) {
        this.$http.delete(`/api/admin/users/delete/${id}`).then(({data}) => {
          let buffer = this.rows;
          buffer.splice(index, 1);
          this.rows = buffer;
          toast('تم الحذف بنجاح', 'success');
        }).catch(err => {
          toast('غير قادر على الحذف');
        });
      }
    },
    nextPage(){
      this.currentPage += 1;
      this.getList();
    },
    prevPage(){
      this.currentPage -= 1;
      this.getList();
    },
    goToPage(num){
      this.currentPage = num;
      this.getList();
    },
    filterSubmit(){
      this.currentPage = 1;
      this.getList();
    },
    clearFilter(){
      this.currentPage = 1;
      this.searchName = '';
      this.searchMobile = '';
      this.searchIdentity = '';
      this.searchBlock = null;
      this.searchDateFrom = null;
      this.searchDateTo = null;
      this.searchActivation = '';
      this.getList();
    },
    async exportExcel(){
      try {
        const response = await this.$http.get('/api/admin/users/export', {
          params: this.filterParams(), responseType: 'blob'
        });
        const blob = new Blob([response.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = 'clients.xlsx';
        link.click();
        URL.revokeObjectURL(link.href);
      } catch (err) {
        toast('فشل تصدير الملف', 'error');
      }
    },
    waLink(mobile){
      let num = String(mobile).replace(/[^\d+]/g, '');
      if (num.startsWith('00')) num = '+' + num.slice(2);
      else if (num.startsWith('05')) num = '+966' + num.slice(1);
      else if (num.startsWith('5') && num.length === 9) num = '+966' + num;
      else if (!num.startsWith('+')) num = '+' + num;
      return `https://wa.me/${num}`;
    },
  },
  created(){
    this.getList();
  }
}
</script>